import { FC } from "react";

import { ConfirmActionModal } from "src/components/Modal";
import { useT } from "src/internationalization";

type LogoutModalProps = {
  onConfirm: () => void;
};

const LogoutModal: FC<LogoutModalProps> = ({ onConfirm }) => {
  const t = useT();

  return (
    <ConfirmActionModal
      title={t("logout.modal.title")}
      size={"sm"}
      confirmButtonText={t("logout.modal.button")}
      onConfirm={onConfirm}
    >
      {t("logout.modal.message")}
    </ConfirmActionModal>
  );
};

export default LogoutModal;
